import {API} from '../../Services';

async function StoreOnlineSubCatsData(merchantId,catId,page=1,sort,startPrice,endPrice,available,brands){
    let mallId= localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');
    return API.get(`/shop/${merchantId}/product-public/?category__uid=${catId}&page=${page}&${sort}&price__gt=${startPrice}&price__lt=${endPrice}&is_available=${available}${brands}`);
}

export {StoreOnlineSubCatsData}
